var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import Slides from '../slides';
import { h5PageCount } from '../../../utils';
import { WxLaunchApp } from '../../wxLaunchApp';
const { callApp, getSchemeLink } = require('@ifeng-fe/callapp');
import { Event } from '../../../base/base';
import { handleAd } from '../../../utils';
// import { QQShare } from '../../qqShare';
import { wxShareTool } from '../../../utils/wxShareTool';
const dotTmpl = (current, total) => {
    const dots = [];
    for (let i = 0; i < total; i++) {
        dots.push(React.createElement("span", { key: i, className: current === i ? styles.current : styles.dot }));
    }
    return (React.createElement("div", { className: styles.dots_box },
        React.createElement("div", { className: styles.dots }, dots)));
};
class BottomSlides extends React.PureComponent {
    constructor(props) {
        super(props);
        this.currentIndex = 0;
        this.event = new Event();
        this.androidAppIconHandle = () => {
            var _a;
            const UA = navigator.userAgent.toLocaleLowerCase();
            if (wxShareTool && UA.toLocaleLowerCase().match(/android/) && /micromessenger/i.test(UA)) {
                this.setState({
                    isShowAppIcon: false,
                });
            }
            else {
                this.setState({
                    isShowAppIcon: true,
                });
            }
            (_a = wxShareTool === null || wxShareTool === void 0 ? void 0 : wxShareTool.on) === null || _a === void 0 ? void 0 : _a.call(wxShareTool, 'showAppIcon', () => {
                this.setState({
                    isShowAppIcon: true,
                });
            });
            setTimeout(() => {
                if (!this.state.isShowAppIcon) {
                    this.setState({
                        isShowAppIcon: true,
                    });
                }
            }, 3000);
        };
        this.addLogoPicHandle = () => {
            const { aidIndex } = this.props;
            const { content } = this.state;
            if (aidIndex && aidIndex.length > 0) {
                for (const index of aidIndex) {
                    content.splice(index, 0, this.aid);
                }
                this.setState({
                    content,
                });
            }
        };
        // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
        this.insert = (insertArr, replaceArr, adFn) => {
            if (adFn && typeof adFn === 'function') {
                const { content } = this.props;
                const infoData = [...content];
                const refs = [];
                // 广告插入，在指定位置后插入广告位数据
                insertArr.forEach((item) => {
                    if (item === 0 || item === infoData.length - 1) {
                        const ref = React.createRef();
                        refs.push({ index: item, ref });
                        infoData.splice(item, 0, { type: 'ad', ref });
                    }
                    else {
                        const ref = React.createRef();
                        refs.push({ index: item, ref });
                        infoData.splice(item, 0, { type: 'ad', ref });
                    }
                });
                // 广告替换，在指定位置删除原数据，替换为广告位数据
                replaceArr.forEach((item) => {
                    if (item === 0 || item === infoData.length - 1) {
                        const ref = React.createRef();
                        refs.push({ index: item, ref });
                        infoData.splice(item, 1, { type: 'ad', ref });
                    }
                    else {
                        const ref = React.createRef();
                        refs.push({ index: item, ref });
                        infoData.splice(item, 1, { type: 'ad', ref });
                    }
                });
                // 广告数据整合处理完毕后，更新列表数据
                this.setState({
                    content: infoData,
                }, () => {
                    const dom = {};
                    for (const ref of refs) {
                        if (ref.ref && ref.ref.current) {
                            dom[ref.index] = [ref.ref.current];
                        }
                        else if (ref.ref && ref.ref.current) {
                            dom[ref.index] = ref.ref.current;
                        }
                    }
                    try {
                        adFn(dom);
                    }
                    catch (e) {
                        console.error(e);
                        this.setState({
                            content,
                        });
                    }
                });
            }
            return;
        };
        this.handleClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
            const { isVideoShare } = this.props;
            const { content } = this.state;
            const item = content[this.currentIndex] || {};
            // const docType = item.newstype || 'bottomNav';
            const docType = item.newstype || 'awake';
            const aid = item._id || item.id;
            const clickCountConfig = item.clickCount || {};
            const kind = item.kind || content[0].kind || '';
            const noPrefixKind = item.noPrefixKind || '';
            const client = isVideoShare ? 'videoApp' : 'newsApp';
            const downloads = item.downloads || content[0].downloads || { download: '', downloadAd: '' };
            // const phoenixConfig = docType === 'bottomNav' ? { navId: 'bottomNavVideo', pid: 'vch_phoenix'} : {};
            if (item.channel !== 'treasure') {
                if (isSendCount && clickCountConfig.type) {
                    this.feedClickCountFn(clickCountConfig, item.abTest, item.toId, this.currentIndex);
                }
                if (isJumpQQlink && clickCountConfig.other) {
                    clickCountConfig.other.tag = 't9';
                    this.feedClickCountFn(clickCountConfig, item.abTest, item.toId, this.currentIndex);
                }
                if (isCallApp) {
                    callApp({
                        client,
                        docType,
                        pid: aid,
                        kind,
                        download: downloads.download,
                        downloadAd: downloads.downloadAd,
                        noKindFrom: noPrefixKind,
                        isCopySchemeUrl: isJumpQQlink,
                    });
                }
            }
            else {
                this.handleCallTreasure(item);
            }
        };
        this.handleCallTreasure = (item) => {
            const shareUrl = item.share || '';
            const dlUrl = item.dlUrl || '';
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'to_tmall',
                },
            ]);
            this.taobaoExp(this.state.tbClickUlr);
            setTimeout(() => {
                location.href = dlUrl;
            }, 50);
            setTimeout(() => {
                location.href = shareUrl;
            }, 2000);
        };
        this.feedClickCountFn = (config, abTest, id, num) => {
            const typeValue = abTest ? `downopen_${abTest}` : 'downopen';
            if (!config) {
                config = {
                    behavior: 'action',
                    type: 'downopen',
                    other: {
                        ref: encodeURIComponent(document.referrer),
                        kind: 'article',
                        url: encodeURIComponent(location.href),
                    },
                };
            }
            config.type = typeValue;
            if (config.other) {
                config.other.to = id;
                config.other.num = num;
            }
            h5PageCount([config]);
        };
        this.afterSlide = (currentIndex, total) => {
            this.currentIndex = currentIndex;
            const { content } = this.state;
            const liveSlideData = content[this.currentIndex];
            this.setState({
                liveSlideData,
            });
        };
        this.afterAutoplay = (currentIndex, total) => {
            this.taobaoExp(this.state.tbExpUrl);
            this.currentIndex = currentIndex;
            const { content } = this.state;
            const liveSlideData = content[this.currentIndex];
            this.setState({
                liveSlideData,
            });
        };
        this.taobaoExp = (url) => {
            const { content } = this.props;
            const item = content[this.currentIndex];
            if (item && item.channel === 'treasure') {
                const imgDom = document.createElement('img');
                imgDom.style.display = 'none';
                imgDom.src = url;
                document.body.appendChild(imgDom);
            }
        };
        this.sliderTmpl = (item, isClone, index) => {
            const { isVideoShare } = this.props;
            let schemeLink = getSchemeLink({
                docType: item.newstype || 'awake',
                pid: item._id || item.id || '',
                kind: item.kind || 'share01',
                noPrefixKind: item.noPrefixKind || '',
            });
            if (item.wxLaunchType === 'weapp') {
                schemeLink = `pages/new/new.html?aid=ucms_${item.id}&types=doc&showtype=titleimg&ref=sy&from=wxh5`;
            }
            if (item.type === 'ad') {
                return React.createElement("div", { className: styles.swiper, ref: item.ref, "data-index": index, id: "bottomSlideAdBox" });
            }
            else if (item.type === 'aid') {
                return (React.createElement("div", { className: styles.swiper, "data-index": index },
                    React.createElement("div", { className: styles.swiper_item, onClick: this.handleClick, id: "testid" },
                        React.createElement("span", { className: styles.img_box },
                            isVideoShare && React.createElement("span", { className: styles.videoLogo }),
                            !isVideoShare && React.createElement("span", { className: styles.logo })),
                        !isVideoShare && item.wxLaunchSwitch && (React.createElement(WxLaunchApp, { launchType: item.wxLaunchType, 
                            // schemeLink={schemeLink}
                            launchAppClick: this.handleClick.bind(this, true, false, false), launchAppFail: this.handleClick.bind(this, false, true, true) })))));
            }
            else if (item.type === 'web') {
                return (React.createElement("div", { className: styles.swiper, "data-index": index },
                    React.createElement("div", { className: styles.swiper_item, onClick: this.handleClick },
                        React.createElement("img", { className: styles.webPic, src: item.thumbnailpic }),
                        !isVideoShare && item.wxLaunchSwitch && (React.createElement(WxLaunchApp, { launchType: item.wxLaunchType, schemeLink: schemeLink, launchAppClick: this.handleClick.bind(this, true, false, false), launchAppFail: this.handleClick.bind(this, false, true, true) })))));
            }
            else {
                return (React.createElement("div", { className: styles.swiper, "data-index": index },
                    React.createElement("div", { className: styles.swiper_item, onClick: this.handleClick },
                        React.createElement("span", { className: styles.img_box }, item.thumbnailpic && React.createElement("img", { src: item.thumbnailpic, className: styles.pic })),
                        React.createElement("span", { className: styles.title },
                            React.createElement("span", { className: styles.titleBox }, item.title)),
                        !isVideoShare && item.wxLaunchSwitch && (React.createElement(WxLaunchApp, { launchType: item.wxLaunchType, schemeLink: schemeLink, launchAppClick: this.handleClick.bind(this, true, false, false), launchAppFail: this.handleClick.bind(this, false, true, true) })))));
            }
        };
        this.aid = {
            type: 'aid',
            wxLaunchType: this.props.content && this.props.content[0] && this.props.content[0].wxLaunchType,
            wxLaunchSwitch: this.props.content && this.props.content[0] && this.props.content[0].wxLaunchSwitch,
        };
        this.state = {
            isHasSlide: true,
            liveSlideData: (this.props.content && this.props.content[0]) || {},
            content: this.props.content,
            isShowAppIcon: false,
            tbExpUrl: 'https://ef-dongfeng.tanx.com/nim?e=lx4Y7A3_nZd5PDnPARRLae3JIevFpEOkl_KY_7WeQ2x6PewBERzQx0-wQ6Rp9v30a81ennGjQpfV4m9hs_FgQ-OtOnnqSEbsXCmuVdd8Eu4&k=106&ext=a%3d__IMEI__%26b%3d__IDFA__%26c%3d__MAC__%26d%3d__OAID__',
            tbClickUlr: 'https://ef-dongfeng.tanx.com/ncm?e=lx4Y7A3_nZd5PDnPARRLae3JIevFpEOkl_KY_7WeQ2x6PewBERzQx0-wQ6Rp9v30a81ennGjQpfV4m9hs_FgQ-OtOnnqSEbsXCmuVdd8Eu4&k=106&ext=a%3d__IMEI__%26b%3d__IDFA__%26c%3d__MAC__%26d%3d__OAID__',
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            this.androidAppIconHandle();
            this.addLogoPicHandle();
            this.taobaoExp(this.state.tbExpUrl);
            const { ad } = this.props;
            if (ad) {
                try {
                    const callback = yield handleAd(ad);
                    callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
                }
                catch (e) {
                    console.error(e);
                }
                try {
                    this.event.trigger('init'); // 触发广告位插入方法
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    }
    render() {
        let { noCloseIcon = false, maxWidth = '1024px', isVideoShare } = this.props;
        let { content, isShowAppIcon } = this.state;
        const filterContent = content.filter((item) => {
            return item.newstype !== 'nodata';
        });
        const { isHasSlide, liveSlideData } = this.state;
        const config = {
            sliderTmpl: this.sliderTmpl,
            dotTmpl,
            autoplay: !(filterContent.length === 0),
            dots: !(filterContent.length === 0),
            afterSlide: this.afterSlide,
            afterAutoplay: this.afterAutoplay,
        };
        const noCloseIconName = noCloseIcon ? styles.noCloseIcon : '';
        let schemeLink = getSchemeLink({
            docType: liveSlideData.newstype || 'awake',
            pid: liveSlideData._id || liveSlideData.id || '',
            kind: liveSlideData.kind || 'share01',
            noPrefixKind: liveSlideData.noPrefixKind || '',
        });
        if (liveSlideData.wxLaunchType === 'weapp') {
            schemeLink = `pages/new/new.html?aid=ucms_${liveSlideData.id}&types=doc&showtype=titleimg&ref=sy&from=wxh5`;
            if (!liveSlideData.id) {
                schemeLink = '';
            }
        }
        const adDom = typeof window === 'object' ? document.querySelector('#bottomSlideAdBox') : null;
        let adIndex = '';
        let adDomIframeUrl = '';
        let adDomAUrl = '';
        if (adDom) {
            adIndex = parseInt(adDom.getAttribute('data-index'));
            if (adDom.querySelector('iframe')) {
                adDomIframeUrl = adDom.querySelector('iframe').getAttribute('url');
            }
            if (adDom.querySelector('a')) {
                adDomAUrl = adDom.querySelector('a').getAttribute('href');
            }
        }
        return (isHasSlide && (React.createElement("div", { className: styles.box, style: { maxWidth } },
            React.createElement("div", { className: styles.silde_box },
                React.createElement(Slides, { content: content, config: config })),
            adIndex !== this.currentIndex + 1 ? (React.createElement("div", { className: `${styles.opt} ${noCloseIconName}`, onClick: this.handleClick },
                isShowAppIcon && React.createElement("span", { className: styles.btn }, "\u6253\u5F00"),
                React.createElement("span", { className: styles.close }),
                !isVideoShare && liveSlideData.wxLaunchSwitch && (React.createElement(WxLaunchApp, { launchType: liveSlideData.wxLaunchType, schemeLink: schemeLink, launchAppClick: this.handleClick.bind(this, true, false, false), launchAppFail: this.handleClick.bind(this, false, true, true) })))) : (React.createElement("div", { className: `${styles.opt} ${noCloseIconName}` },
                isShowAppIcon && React.createElement("span", { className: styles.btn }, "\u6253\u5F00"),
                React.createElement("span", { className: styles.close }),
                adDomIframeUrl && (React.createElement("iframe", { frameBorder: "0", scrolling: "no", className: styles.iframeBox, src: adDomIframeUrl })),
                adDomAUrl && React.createElement("a", { href: adDomAUrl, className: styles.iframeBox }))))));
    }
}
export default BottomSlides;
